module.exports = __webpack_public_path__ + "img/icon_save_emt.9664434a.png";